import * as z from 'zod'

import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_cohabitants = (params: StepConfigParams) =>
  ({
    schema: z.object({
      cohabitants: BaseSchema_HouseholdV1GetsafeAt.shape.cohabitants.unwrap().min(1),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.cohabitants.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.cohabitants.subtitle',
        },
      },
      {
        type: 'editableSet',
        name: 'cohabitants',
        addItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.cohabitants.addNewCohabitant',
        },
        removeItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.cohabitants.remove',
        },
        configuration: {
          title: {
            type: 'translatableText',
            translationKey: 'sharedFlows_householdAt:steps.cohabitants.configTitle',
          },
          elements: [
            {
              type: 'input',
              name: 'first_name',
              label: {
                type: 'translatableText',
                translationKey:
                  'sharedFlows_householdAt:steps.cohabitants.elements.firstName.input.label',
              },
              styleType: 'outlined',
            },
            {
              type: 'input',
              name: 'last_name',
              label: {
                type: 'translatableText',
                translationKey:
                  'sharedFlows_householdAt:steps.cohabitants.elements.lastName.input.label',
              },
              styleType: 'outlined',
            },
            {
              type: 'date',
              name: 'date_of_birth',
              styleType: 'outlined',
            },
          ],
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_deductible_amount,
  }) as const satisfies AnyStepConfiguration

export default household_at_cohabitants
